export var ETaskStatus;
(function (ETaskStatus) {
    ETaskStatus["NEW"] = "NEW";
    ETaskStatus["TODO"] = "TODO";
    ETaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ETaskStatus["COMPLETED"] = "COMPLETED";
    ETaskStatus["REVIEW"] = "REVIEW";
    ETaskStatus["REJECTED"] = "REJECTED";
})(ETaskStatus || (ETaskStatus = {}));
